export type LabKind = 'derivative' | 'vectors' | 'flux' | 'reynolds' | 'poiseuille' | 'diffusion' | 'advection' | 'projection' | 'iteration' | 'cutcell' | 'convergence';
export type Question = {
  id: string;
  prompt: string;
  options?: string[];
  correctIndex?: number;
  answer?: number;
  tolerance?: number;
  unit?: string;
  explanation: string;
};
export type Chapter = {
  id: string;
  number: number;
  part: number;
  title: string;
  subtitle: string;
  minutes: number;
  prerequisites: string[];
  goals: string[];
  intuition: string;
  sections: { title: string; body: string }[];
  derivation: { title: string; steps: { title: string; math?: string; explanation: string }[] };
  workedExample: { title: string; body: string };
  pitfalls: string[];
  lab?: LabKind;
  questions: Question[];
  hardProblem: { title: string; prompt: string; hints: string[]; solution: string; rubric: string[] };
  code: { title: string; sourcePath: string; pseudocode: string; explanation: string };
  references: { title: string; url: string; note: string }[];
};
export const parts = [
  { id: 1, title: 'Rebuild the foundations', subtitle: 'The mathematics comes back.', color: '#b3cc9a' },
  { id: 2, title: 'Think in fields', subtitle: 'From a point to a moving fluid.', color: '#a9c5db' },
  { id: 3, title: 'Let physics lead', subtitle: 'Conservation becomes an equation.', color: '#dac49c' },
  { id: 4, title: 'Make it discrete', subtitle: 'A continuous world, a finite grid.', color: '#bdb0d8' },
  { id: 5, title: 'Advance the flow', subtitle: 'One carefully constructed time step.', color: '#a4c9bc' },
  { id: 6, title: 'Solve the pressure', subtitle: 'Constraints, geometry, and linear algebra.', color: '#d4aab0' },
  { id: 7, title: 'Trust the result', subtitle: 'From solver output to physical evidence.', color: '#abc6c6' }
];
